// extracted by mini-css-extract-plugin
export default {"breadcrumbItem":"PageTitle_breadcrumbItem__JVTWW","breadcrumbIcon":"PageTitle_breadcrumbIcon__VsT-h","breadcrumb":"PageTitle_breadcrumb__jd5HP"};